import * as React from "react";
import Svg from "../Svg.tsx";

export default function CloseIcon({
  color = "var(--text-color)",
  ...otherProps
}: {
  color?: string;
} & Omit<
  React.ComponentPropsWithoutRef<typeof Svg>,
  "viewBox"
>): React.ReactElement {
  return (
    <Svg viewBox="0 0 55 55" {...otherProps}>
      <path
        d="M5 5l45 45M5 50L50 5"
        fill="none"
        stroke={color}
        strokeWidth="10"
        strokeLinecap="round"
        strokeMiterlimit="10"
      />
    </Svg>
  );
}
